import moment from 'moment';

require('moment/locale/fr');

moment.locale('fr');

export default moment;
